class ReservationTimer extends HTMLElement {
  connectedCallback() {
    this.display = this.querySelector('[data-timer-display]');
    this.durationMinutes = parseInt(this.dataset.duration, 10) || 15;
    this.storageKey = 'cartReservationExpiry';

    this.checkCart = this.checkCart.bind(this);

    this.init();
    this.bindCartEvents();
  }

  init() {
    const now = Date.now();
    let expiry = sessionStorage.getItem(this.storageKey);
    expiry = expiry ? parseInt(expiry, 10) : null;

    if (!expiry || expiry <= now) {
      expiry = now + this.durationMinutes * 60 * 1000;
      sessionStorage.setItem(this.storageKey, expiry);
    }

    this.expiry = expiry;
    this.tick();
    this.startInterval();
  }

  startInterval() {
    clearInterval(this.interval);
    this.interval = setInterval(() => this.tick(), 1000);
  }

  // Reinicia o temporizador para a duração completa outra vez
  reset() {
    const now = Date.now();
    const expiry = now + this.durationMinutes * 60 * 1000;

    sessionStorage.setItem(this.storageKey, expiry);
    this.expiry = expiry;
    this.tick();
    this.startInterval();
  }

  bindCartEvents() {
    document.addEventListener('cart:updated', this.checkCart);
    document.addEventListener('cart:change', this.checkCart);
    window.addEventListener('cart:refresh', this.checkCart);

    if (!window.reservationTimerFetchIntercepted) {
      window.reservationTimerFetchIntercepted = true;

      const originalFetch = window.fetch;
      window.fetch = async function () {
        const response = await originalFetch.apply(this, arguments);
        const url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0]?.url || '');

        if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
          setTimeout(() => {
            document.querySelectorAll('reservation-timer').forEach((el) => el.checkCart());
          }, 500);
        }

        return response;
      };

      const origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function () {
        this.addEventListener('load', function () {
          if (this.responseURL && this.responseURL.includes('/cart/')) {
            setTimeout(() => {
              document.querySelectorAll('reservation-timer').forEach((el) => el.checkCart());
            }, 500);
          }
        });
        origOpen.apply(this, arguments);
      };
    }
  }

  // Verifica o estado real do carrinho e reinicia o temporizador se estiver vazio
  async checkCart() {
    try {
      const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      const res = await fetch(rootUrl + 'cart.js');
      const cart = await res.json();

      if (cart.item_count === 0) {
        this.reset();
      }
    } catch (e) {
      console.error('Erro ao verificar o carrinho para o temporizador de reserva:', e);
    }
  }

  tick() {
    const remaining = this.expiry - Date.now();

    if (remaining <= 0) {
      clearInterval(this.interval);
      if (this.display) this.display.textContent = '00:00';
      sessionStorage.removeItem(this.storageKey);
      return;
    }

    const minutes = Math.floor(remaining / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);

    if (this.display) {
      this.display.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }
  }

  disconnectedCallback() {
    clearInterval(this.interval);
    document.removeEventListener('cart:updated', this.checkCart);
    document.removeEventListener('cart:change', this.checkCart);
    window.removeEventListener('cart:refresh', this.checkCart);
  }
}

if (!customElements.get('reservation-timer')) {
  customElements.define('reservation-timer', ReservationTimer);
}